const bits = [16, 8, 4, 2, 1];
const base32 = '0123456789bcdefghjkmnpqrstuvwxyz';

export const decode = (hash: string, num: number): number[] => {
  if (typeof num === 'undefined') {
    throw new Error('`num` required');
  }

  const ranges = [];
  for (let i = 0; i < num; i++) {
    ranges[i] = [-100, 100];
  }
  let id = 0;

  for (let i = 0; i < hash.length; i++) {
    for (let j = 0; j < bits.length; j++) {
      const range = ranges[id++ % ranges.length];
      // eslint-disable-next-line no-bitwise
      const side = base32.indexOf(hash[i]) & bits[j] ? 0 : 1;
      range[side] = avg(range);
    }
  }

  const averaged = [];
  for (let i = 0; i < ranges.length; i++) {
    averaged[i] = avg(ranges[i]);
  }
  return averaged;
};

export interface HashOptions {
  precision?: number;
}

export const encode = (values: number[], options?: HashOptions): string => {
  if (!options) {
    options = {};
  }

  const precision = options.precision || 12;

  const ranges = [];
  for (let i = 0; i < values.length; i++) {
    if (values[i] < -100 || values[i] > 100) {
      throw new Error(`accepted input range: [-100, 100]: value at ${i}: ${values[i]}`);
    }
    ranges[i] = [-100, 100];
  }

  let hash = '';
  let i = 0;
  let bit = 0;
  let ch = 0;

  while (hash.length < precision) {
    const arg = i++ % values.length;
    const range = ranges[arg];
    const value = values[arg];
    const mid = avg(range);

    if (value > mid) {
      // eslint-disable-next-line no-bitwise
      ch |= bits[bit];
      range[0] = mid;
    } else {
      range[1] = mid;
    }

    if (bit < 4) {
      bit++;
    } else {
      hash += base32[ch];
      bit = 0;
      ch = 0;
    }
  }

  return hash;
};

function avg(r: number[]): number {
  return (r[0] + r[1]) / 2;
}
